import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { XMarkIcon } from '@heroicons/react/24/outline';

const CAMPAIGN_END = new Date('2026-05-17T00:00:00');
const DISMISS_KEY = 'jpo-banner-dismissed';
const TARGET = '/portes-ouvertes?utm_source=site&utm_medium=banner&utm_campaign=jpo-mai';

const JpoBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (new Date() >= CAMPAIGN_END) return;
    if (sessionStorage.getItem(DISMISS_KEY)) return;
    setVisible(true);
  }, []);

  const dismiss = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    sessionStorage.setItem(DISMISS_KEY, '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Link
      to={TARGET}
      className="block bg-primary text-gray-900 hover:bg-primary-dark hover:text-white transition-colors"
    >
      <div className="container mx-auto px-4 py-2.5 flex items-center justify-between gap-3">
        <p className="flex-1 text-sm md:text-base text-center md:text-left leading-snug">
          <strong>Journée Portes Ouvertes — Samedi 16 mai</strong>
          <span className="hidden md:inline">
            {' '}· Test gratuit pour votre enfant (Maternelle &amp; Primaire)
          </span>
          <span className="ml-2 underline font-semibold whitespace-nowrap">
            Réservez votre place →
          </span>
        </p>
        <button
          onClick={dismiss}
          aria-label="Fermer la bannière"
          className="flex-shrink-0 rounded-full p-1 hover:bg-black/10"
        >
          <XMarkIcon className="h-5 w-5" />
        </button>
      </div>
    </Link>
  );
};

export default JpoBanner;
